import Vue from 'vue'
import Vuex from 'vuex'
import cart from './modules/cart'
import airtimeproduct from './modules/airtimeproduct'
import alertmessage from './modules/alertmessage'
import login from './modules/login'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

export function Persist():boolean
{
  return localStorage.getItem('vuex')!==null
}

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    cart,
    login,
    airtimeproduct,
    alertmessage,
  },
  plugins: [new VuexPersistence().plugin],
})


